<template>
  <div class="main-block">
    <div v-if="marker"
         v-bind:class="{'ribbon ribbon-top-right':true, 'c_orange': marker.color === 1, 'c_blue': marker.color === 2}">
      <span>{{ marker.text }}</span></div>
    <div>
      <p>Заявка: <strong>{{ (order.id + '').substr(-4) }}</strong>
        ({{ $AllProjects[order.site_id] && $AllProjects[order.site_id].name }})
        <span class="badge badge-warning" v-if="isNoReply()">недозвон</span>
        <span class="float-right badge badge-dark" style="font-size:27px">{{ order.line_order }}</span>
      </p>
      <p><strong>Клиент:</strong> {{ order.client_name || (order.client && order.client.name) }}</p>
      <p>Телефоны:</p>
      <div v-for="phone in order.order_phones" class="phone_div" v-if="phone.phone">
        <p><a :href="`tel:${phone.phone.phone}`">{{ mixinPrintPhone('00' + phone.phone.phone) }}</a></p>
        <p v-if="phone.phone && phone.phone.comment">{{ phone.phone.comment }}</p>
      </div>
      <p><strong>Адрес:</strong></p>
      <p class="fs-18"><strong>{{ order.address }}</strong></p>
      <p v-if="order.extra_options.address_details">{{ order.extra_options.address_details }}</p>
      <template v-if="order.metro_station && order.metro_station.line">
        <p class="metro_line"><span class="badge fs-18" :style="{backgroundColor: order.metro_station.line.color}"> {{
            order.metro_station.line.number
          }}</span> {{ order.metro_station.line.title }}
        </p>
        <p><i class="icon-fa icon-fa-subway fs-18"></i> {{ order.metro_station.title }}</p>
      </template>
    </div>
    <div class="table_block">
      <table class="table table-sm">
        <thead>
        <tr>
          <th>Препарат</th>
          <th>Кол</th>
          <th>Стоимость</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="detail in order.details">
          <td>
            <i v-if="detail.new_drug.cool" class="icon icon-snowflake"/> {{ detail.new_drug.title }}
            <div v-if="(detail?.extra_data?.comments ?? []).length" class="alert alert-info p-1">
              <p v-for="comment in detail.extra_data.comments">{{ comment.text }}</p>
            </div>
            <p></p>
          </td>
          <td>{{ detail.qty }}</td>
          <td class="text-muted">{{ detail?.currency_price ?? detail.price }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-if="marker" class="alert alert-danger">
          <p>Выдать в пакете с визиткой <strong>Фарма-Логист</strong></p>
        </div>
        <template v-if="order.extra_options.runner_comments && order.extra_options.runner_comments.length">
          <p class="text-muted">Мои комментарии</p>
          <div class="comment_block" v-for="comment in order.extra_options.runner_comments">
            <div class="mb-0" v-html="comment.message"/>
            <small v-if="comment.created_at" class="text-muted">{{ moment(comment.created_at, 'HH:mm') }}</small>
          </div>
        </template>
      </div>
    </div>
    <div class="flex justify-content-between">
      <div class="mt-1">
        <UploadFile :order-id="order.id" type="runnersFile"/>
        <div class="mt-1">
          <FastCallBackRequest :order="order"/>
        </div>
      </div>
      <div class="text-right">
        <p><strong>{{ printDate(order.delivery_date, 'DD.MM.YYYY') }}</strong></p>
        <p>доставка: <strong>{{ order.currency_delivery ?? order.delivery_price ?? 0 }}</strong></p>
        <p>скидка: <strong>{{ order.discount || 0 }}</strong></p>
        <template v-if="+order.pay_method === 3">
          <p>к оплате наличными <strong class="badge badge-info fs-18">{{ order.price - order.no_cash_price }}</strong>
            руб</p>
          <p>(предоплата <strong class="badge badge-info fs-18">{{ order.no_cash_price }}</strong> руб, получена)</p>
        </template>
        <template v-if="+order.pay_method !== 3 && order.credit_card_id">
          <p>к оплате наличными <strong class="badge badge-info fs-18">{{ order.price }}</strong>
            руб</p>
          <div class="alert alert-info" v-if="order.credit_card">
            <p>Карта для оплаты</p>
            <p><strong>{{ order.extra_options.card_number }}</strong></p>
            <p>Получатель</p>
            <p><strong>{{ order?.credit_card?.owner?.full_name }}</strong></p>
          </div>
          <div class="alert alert-success" v-if="smsPayment && smsPayment.length">
            <p>Найдены СМС с зачислением средств</p>
            <p v-for="sms in smsPayment"><strong>{{ printDate(sms.date) }} {{ sms.message }}
              <LoadingButton
                title="Подтвердить оплату"
                :loading="loadingBtn"
                color="white"
                :onClick="() => confirmPayment(sms)"
                className="btn btn-success btn-xs"
              />
            </strong>
            </p>
          </div>
          <div class="alert alert-warning">
            <p>Клиент сообщил о намерении сделать предоплату на карту в размере
              <strong>{{ order.no_cash_price }}</strong> руб, тогда сумма к оплате наличными будет
              <strong>{{ order.price - order.no_cash_price }}</strong> руб.</p>
            <p>Но предоплата ЕЩЕ НЕ получена. Нельзя доставлять эту заявку БЕЗ получения наличных и без подтверждения
              предоплаты на карту</p>
          </div>
        </template>
        <!--        <template v-if="+order.pay_method === 1 && !order.credit_card_id">-->
        <!--        </template>-->
        <div class="flex justify-content-between mb-2" v-if="false">
          <template v-if="+order.pay_method === 1 && !order.credit_card_id">
            <LoadingButton
              title="Получить реквизиты для оплаты по карте"
              type="button"
              :loading="loadingRequestBtn[order.id]"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => requestNoCashPayment(order)"
              className="btn btn-outline-success btn-xs"
            />
          </template>

          <div>
            <LoadingButton
              v-if="+order.pay_method !== 3 && order.credit_card_id"
              title="Запросить обновление оплаты"
              type="button"
              :loading="loadingRequestBtn[order.id]"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => requestPaimentCheck(order)"
              className="btn btn-outline-success btn-xs"
            />
          </div>
          <LoadingButton
            title="Обновить статус заявки"
            type="button"
            :loading="loadingBtn"
            :color="$constants.PRIMARY_COLOR"
            :onClick="() => {reloadOrder()}"
            className="btn btn-outline-info btn-xs"
          />
        </div>
      </div>
    </div>

    <div class="flex justify-content-between">
      <div v-if="$currentUID === 257">
        <PayByCrypto :orderId="order.id"/>
      </div>
      <p>итого: <strong class="badge badge-info fs-18">{{ order.currency_id_price ?? order.price }}</strong></p>
    </div>

    <div class="flex justify-content-between">
      <div>
        <p><a href="#" @click.prevent='openMessages("comments")'>Комментарии офис
          ({{ order.extra_options.comments_for_runner && order.extra_options.comments_for_runner.length || 0 }})</a></p>
      </div>
      <div v-if="order.messages && order.messages.length">
        <p><a href="#" @click.prevent='openMessages("messages")'>Диалоги ({{ order.messages.length }})</a></p>
      </div>
    </div>

    <div class="all_questions question" v-if="showComments">
      <div v-for="comment in order.extra_options.comments_for_runner">
        <p>{{ comment.text }}</p>
        <p class="text-right text-muted">{{ moment(comment.created_at, 'DD.MM HH:mm') }}</p>
      </div>
    </div>

    <div class="all_questions" v-if="showMessages">
      <div class="question" v-for="message in (order.messages || [])">
        <p>
          <i v-bind:class="{'icon-fa': true,
                'icon-fa-arrow-circle-left blue': $currentUID === message.to_user_id,
                'icon-fa-arrow-circle-right green': $currentUID === message.user_id,
                }"></i>
          <span v-html="message.text"/>
        </p>
        <p class="text-right text-muted">{{ moment(message.created_at, 'DD.MM HH:mm') }}</p>
        <div v-for="answer in message.answers">
          <p>
            <i v-bind:class="{'icon-fa': true,
                'icon-fa-arrow-circle-left blue': $currentUID === answer.to_user_id,
                'icon-fa-arrow-circle-right green': $currentUID === answer.user_id,
                }"></i>
            <span v-html="answer.text"/>
          </p>
          <p class="text-right text-muted">{{ moment(answer.created_at, 'DD.MM HH:mm') }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import moment from 'moment'
import LoadingButton from "@/components/buttons/LoadingButton";
import api from "@/api";
import UploadFile from "@/components/files/UploadFile.vue";
import PayByCrypto from "@/views/tablet/orders/components/PayByCrypto.vue";
import FastCallBackRequest from "@/views/components/runners/FastCallBackRequest.vue";

export default {
  components: {FastCallBackRequest, PayByCrypto, UploadFile, LoadingButton},
  props: ['order', 'refreshOrder', 'smsPayment'],
  data() {
    return {
      marker: null,
      loadingRequestBtn: {},
      loadingBtn: false,
      showMessages: false,
      showComments: false,
    }
  },
  created() {
    if (this.order.city_id === 1) {
      if (this.order.site_id === 13) {
        // this.marker = {text: 'Фарма-Логист', color: 2}
      }
      // if (this.order.site_id === 4) {
      //   this.marker = {text: 'МедЛогистик', color: 1}
      // }
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
      return sites
    },
  },
  methods: {
    async requestNoCashPayment(order) {
      this.loadingRequestBtn[order.id] = true;
      this.loadingRequestBtn = {...this.loadingRequestBtn}
      const {data} = await api.post('/new/orders/updateByAction', {
        order_id: this.order.id,
        action: 'setPrePaidData',
      });
      if (data.success) {
        toastr['success']('Реквизиты выданы, обновляйте периодически статус заявки для поиска оплаты');
        if (this.refreshOrder) this.refreshOrder(true);
      } else {
        toastr['warning'](data.message || 'сервер не ответил', 'Ошибка')
      }
      this.loadingRequestBtn[order.id] = false;
    },
    async confirmPayment(sms) {
      this.loadingBtn = true;
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'addPrePaidData',
        order_id: this.order.id,
        comment: sms.message,
        record: sms,
      });
      if (data.success) {
        this.order.pay_method = 3;
        toastr['success']('Оплата подтверждена, заявка может быть доставлена', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loadingBtn = false;
    },
    async requestPaimentCheck(order) {
      this.loadingRequestBtn[order.id] = true;
      this.loadingRequestBtn = {...this.loadingRequestBtn}

      const {data} = await api.post('orders/updateOrderByRunner', {
        type: 'send_payment_check_request',
        order_id: this.order.id,
        data: {comment: 'Запрос на проверку оплаты, через банк'}
      })

      // const {data} = await api.post('/new/chat/dialog', {
      //   type: 6,
      //   order_id: this.order.id,
      // })
      if (data.success) {
        toastr['success']('Запрос создан, ожидайте обратной связи', 'Отправлено');
      } else {
        toastr['warning'](data.message || 'сервер не ответил', 'Ошибка')
      }
      this.loadingRequestBtn[order.id] = false;
    },
    async reloadOrder() {
      this.loadingBtn = true;
      if (this.refreshOrder) {
        this.refreshOrder();
      }
    },
    openMessages(type) {
      this.showMessages = false
      this.showComments = false
      switch (type) {
        case 'comments':
          this.showComments = true
          break
        case 'messages':
          this.showMessages = true
          break
      }
    },
    isNoReply() {
      if (this.order.extra_options.no_reply && moment().format('DD.MM.YYYY') === moment(this.order.extra_options.no_reply.date).format('DD.MM.YYYY')) {
        return true
      }
      return false
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return
      return moment(date).format(format)
    },
  }
}

</script>

<style scoped>
.main-block {
  position: relative;
}

.ribbon {
  width: 250px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}

.ribbon-top-right {
  top: -10px;
  right: -10px;
}

.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}

.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}

.ribbon span {
  position: absolute;
  display: block;
  width: 350px;
  padding: 15px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .1);
  color: #fff;
  font: 700 15px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  text-transform: uppercase;
  text-align: center;
}

.ribbon-top-right::before {
  top: 0;
  left: 0;
}

.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}

.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5BBFDE;
  margin: -3px 4px;
}

table.table td,
.comment_block p {
  font-size: 17px;
}

.fs-18 {
  font-size: 18px;
}

.comment_block p {
  font-weight: bold;
}

.metro_line .badge {
  color: white;
}

.table_block {
  border: 1px solid lightgray;
  padding: 10px 0;
}

.icon-fa.icon-fa-subway {
  width: 20px;
}

.all_questions p {
  margin-bottom: 1px;
}

.question {
  border: 1px solid lightgray;
  padding: 5px;
  margin-bottom: 5px;
}

.question .text-muted {
  font-size: 12px;
}

p {
  margin-bottom: 3px;
}

.icon-fa.green {
  color: #58e858;
}

.icon-fa.blue {
  color: #5BBFDE;
}

.phone_div {
  margin-bottom: 5px;
  background-color: #f4f4f4;
  padding: 1px 10px;
}

.ribbon.c_blue span {
  background-color: #35D5E8;
}

.ribbon.c_orange span {
  background-color: #FF9F00;
}
</style>
